/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./health.vue?vue&type=template&id=0efae23d&scoped=true"
import script from "./health.vue?vue&type=script&lang=js"
export * from "./health.vue?vue&type=script&lang=js"
import style0 from "./health.vue?vue&type=style&index=0&id=0efae23d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efae23d",
  null
  
)

export default component.exports